/**
 * React Query cache key factories for the admin logs pages.
 */

import type { ActionLogFilters, FlowExecutionFilters } from './interfaces';

export const logsKeys = {
  all: ['admin-logs'] as const,
  flowExecutions: (filters: FlowExecutionFilters) => [...logsKeys.all, 'flow-executions', filters] as const,
  flowExecutionCounts: (filters: Omit<FlowExecutionFilters, 'page' | 'limit' | 'status'>) =>
    [...logsKeys.all, 'flow-execution-counts', filters] as const,
  flowExecutionEvents: (executionId: string) => [...logsKeys.all, 'flow-execution-events', executionId] as const,
  actionLogs: (filters: ActionLogFilters) => [...logsKeys.all, 'action-logs', filters] as const
};
